import {ChatContent} from './components/ChatContent';

export const Chat = () => {
    return <ChatContent />;
};
